import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'sizeConvertor',
})
export class SizeConvertor implements PipeTransform {
  transform(filesize: any): string {
    if (!filesize) {
      return;
    }
    filesize = filesize / 1024;

    let filesizeRounded = Math.round(filesize.toFixed(2));

    if (filesizeRounded > 1000) {
      filesize = Math.round(filesize / 1024) + ' MB';
    } else {
      filesize = filesizeRounded + ' KB';
    }

    return filesize;
  }
}
